import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';

interface TrackingContextType {
    trackingId: string;
    setTrackingId: (id: string) => void;
  } 

const TrackingContext = createContext<TrackingContextType | undefined>(undefined);

export const TrackingProvider = ({ children }: { children: ReactNode }) => {
    const [trackingId, setTrackingId] = useState<string>(() => {
      let savedTrackingId = localStorage.getItem('trackingId') ?? '';
      
      if (!savedTrackingId) {
        savedTrackingId = uuidv4();
        localStorage.setItem('trackingId', savedTrackingId);
      }
  
      return savedTrackingId;
    });
  
    // Function to manually update trackingId and persist in localStorage
    const updateTrackingId = (id: string) => {
      setTrackingId(id);
      localStorage.setItem('trackingId', id);
    };
  
    return (
      <TrackingContext.Provider value={{ trackingId, setTrackingId: updateTrackingId }}>
        {children}
      </TrackingContext.Provider>
    );
  };  

export const useTracking = () => {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error('useTracking must be used within a TrackingProvider');
  }
  return context;
};
